import { api } from "./api";

// Admin now rides on the same Google session (cookie), not a separate token.
export const adminApi = api;
export const ADMIN_TOKEN_KEY = "tj-admin-token";
